import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface SurveyFooterProps {
  isSubmitting: boolean;
}

export const SurveyFooter = ({ isSubmitting }: SurveyFooterProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-end space-x-4">
      <Button 
        type="button" 
        variant="outline" 
        onClick={() => navigate("/admin/dashboard")}
      >
        Avbryt
      </Button>
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Skickar..." : "Skicka utvärdering"}
      </Button>
    </div>
  );
};